import { WorkgroupDto } from "../workgroups/WorkgroupDto";

export class PermissionList<T> {

  permissions: T[]

  constructor(permissions: T[] | null) {
    this.permissions = permissions || []
  }

  includes(p: T) {
    return this.permissions.find(item => item === p) !== undefined
  }

  add(p: T) {
    if (this.permissions.find(item => item === p) === undefined) {
      this.permissions.push(p)
    }
  }

  remove(p: T) {
    this.permissions = this.permissions.filter(item => item !== p)
  }
}

export enum AssetPermissions {
  view = "view",
  manage = "manage",
  reports = "reports"
}

export enum PeoplePermissions {
  view = "view",
  reports = "reports"
}

export enum WorkgroupPermissions {
  view_roles = "view_roles",
  create_and_manage_roles = "create_and_manage_roles",
}

export enum SecurityPermissions {
  access_mobile_app = "access_mobile_app",
  access_portal = "access_portal",
  locate_this_person = "locate_this_person"
}

export enum SystemAdminPermission {
  ViewSystemConfiguration = "view_system_configuration",
  ManageUsers = "manage_users",
  ManageGroupsAndRoles = "manage_groups_and_roles",
  ManageSystemAdmins = "manage_system_admins",
}

export enum IntegrationPermission {
  ViewIntegrationConfig = "view_integration_config",
}

export class Role {
  id?: string = "";
  name: string = "";
  workgroup_id: string = "";
  asset_types: string[] | null = null;
  asset_owners: string[] | null = null;
  asset_permissions: AssetPermissions[] | null = null;
  people_options: {
    workgroup_ids: string[],
    permissions: PeoplePermissions[]
  } = {
      workgroup_ids: [],
      permissions: []
    }
  security_permissions: SecurityPermissions[] | null = null
  workgroup_admin_permissions: WorkgroupPermissions[] | null = null
}

export class RoleConfigDto {
  role: Role = new Role()
}

export class RoleListItem extends Role {
  id: string = "";
  workgroup: WorkgroupDto = new WorkgroupDto()
}

export type AuthorizePermissions = {
  localized_user_permissions: {
    permission_to_boundary: Record<PeoplePermissions, {
      workgroup_ids: string[] | null
    }>
  },
  asset_permissions: {
    permission_to_boundary: Record<AssetPermissions, {
      asset_type_ids: string[] | null,
      asset_owner_ids: string[] | null
    }>
  },
  security_permissions: {
    permissions: SecurityPermissions[]
  },
  workgroup_admin_permissions: {
    permission_to_boundary: Record<WorkgroupPermissions, {
      workgroup_ids: string[] | null
    }>
  },
  system_admin_permissions: {
    permissions: SystemAdminPermission[]
  },
  integration_permissions: {
    permissions: IntegrationPermission[]
  }
}